import "./LocationsWeServe.module.css";
import Header from "@/reusable_sections/Header";
import OurPrimaryServiceAreas from "./sections/OurPrimaryServiceAreas";
import DetailedLocationsAndAirports from "./sections/DetailedLocationsAndAirports";
import Footer from "@/reusable_sections/Footer";
export default function LocationsWeServePage() {
  return <div>
      <Header />
      <OurPrimaryServiceAreas />
      <DetailedLocationsAndAirports />
      <Footer />
    </div>;
}